module.exports = __webpack_public_path__ + "img/novelty.9311bb20.png";